import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory, Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { getReportDispatch } from '../../../store/actions/Operation/dispatch';
import Breadcrumbs from '../../CustomControls/Breadcrumb';
import { isEmpty, map } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

const DispatchReport = props => {
  let history = useHistory();
  const dispatchAction = useDispatch();
  let { dispatchid } = useParams();
  const backUrl = '/operation/dispatches';
  const dispatch = useSelector(state => state.dispatch);
  let localPath = `/operation/dispatches/dispatch-report/${dispatchid}`;
  let heading = 'Dispatch Report';
  let reportData = dispatch.dispatchReport;

  const imageResult = window.localStorage.getItem('lmsCompanyLogo');

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: 'Dispatch Listing', path: '/operation/dispatches' },
    { id: 3, title: heading, path: localPath, isCurrent: true }
  ];

  useEffect(() => {
    if (dispatchid) {
      dispatchAction(getReportDispatch(dispatchid));
    }
  }, [dispatchAction, dispatchid]);

  const printInvoice = () => {
    window.print();
  };

  const cancelHandler = () => {
    history.push(backUrl);
  };

  let totalQty = 0;
  if (reportData && reportData.dispatchDetails && reportData.dispatchDetails.length > 0) {
    totalQty = reportData.dispatchDetails.reduce(function(prev, cur) {
      return prev + parseInt(cur.dispatchedQty);
    }, 0);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title={heading} paths={breadCrumbPaths} />
          {!isEmpty(reportData) && (
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                    <div className="report-container">
                      <div className="report-title">
                        <h4 className="float-end font-size-16">Dispatch Note</h4>
                        <div>{imageResult ? <img src={imageResult} alt="logo" height="45" /> : null}</div>
                      </div>
                      <div id="content">
                        <Row>
                          <Col xs="5">
                            <address>
                              <b>{reportData.clientProfileName}</b>
                              <br />
                              <span>
                                {reportData.clientBillingStreetAddress}, {reportData.clientBillingSuburb}, {reportData.clientBillingState},{' '}
                                {reportData.clientBillingPostCode}
                              </span>
                              <br />
                              <span>{reportData.clientPrimaryContactEmail}</span>
                              <br />
                              <span>{reportData.clientPrimaryContactPhone}</span>
                            </address>
                          </Col>
                          <Col xs="7">
                            <address>
                              <Row>
                                <Col xs="3"></Col>
                                <Col xs="5" className="text-end">
                                  Dispatch # :
                                </Col>
                                <Col xs="4" className="text-end">
                                  {reportData.dispatchRef}
                                </Col>
                                <Col xs="3"></Col>
                                <Col xs="5" className="text-end">
                                  Date :
                                </Col>
                                <Col xs="4" className="text-end">
                                  {reportData.dispatchedDate}
                                </Col>
                                <Col xs="3"></Col>
                                <Col xs="5" className="text-end">
                                  Requisition Ref :
                                </Col>
                                <Col xs="4" className="text-end">
                                  {reportData.requisitionRef}
                                </Col>
                                <Col xs="3"></Col>
                                <Col xs="5" className="text-end">
                                  Delivered From :
                                </Col>
                                <Col xs="4" className="text-end">
                                  {reportData.locationName}
                                </Col>
                              </Row>
                            </address>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="6" className="mt-3">
                            <address>
                              <b>Deliver To:</b>
                              <br />
                              <span>{reportData.departmentName}</span>
                              <br />
                              <span>
                                {reportData.departmentAddress}, {reportData.departmentSuburb}, {reportData.departmentState},{' '}
                                {reportData.departmentPostCode}{' '}
                              </span>
                            </address>
                          </Col>
                          <Col xs="6" className="mt-3 text-end"></Col>
                        </Row>
                        <div className="table-responsive">
                          <Table className="table-nowrap">
                            <thead>
                              <tr className="reportLine">
                                <th style={{ width: '15%' }}>Stock Code</th>
                                <th style={{ width: '45%' }}>Description</th>
                                <th style={{ width: '20%' }} className="text-end">
                                  Requested Qty
                                </th>
                                <th style={{ width: '20%' }} className="text-end">
                                  Dispatched Qty
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {map(reportData.dispatchDetails, (item, key) => (
                                <tr key={key}>
                                  <td>{item.productCode}</td>
                                  <td>{item.productName}</td>
                                  <td className="text-end">{item.requestedQty}</td>
                                  <td className="text-end">{item.dispatchedQty}</td>
                                </tr>
                              ))}
                              <tr>
                                <td className="text-start">
                                  <b>{`Line ${reportData.dispatchDetails.length}`}</b>
                                </td>

                                <td colSpan="3" className="text-end">
                                  <b>{`Dispatched Total    :  ${totalQty}`}</b>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="d-print-none">
                        <div className="float-start">
                          <Link to="#" onClick={printInvoice} className="btn btn-outline-primary">
                            <FontAwesomeIcon className="standardIcon" icon={faPrint} /> Print
                          </Link>
                          <Link to="#" onClick={cancelHandler} className="btn btn-secondary w-md button-space">
                            Back
                          </Link>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DispatchReport;
